import { RouteType } from "types/RouteType";
import type InquiryQueueStore from "./InquiryQueueStore";

const storeOf = (rootStore: unknown) =>
  (rootStore as { inquiryQueueViewStore?: InquiryQueueStore }).inquiryQueueViewStore;

/**
 * Clients → Inquiry Queue: the questions we have for clients, before and
 * after they reach the client (plan/2026-10-01_FROM-GANTRY_client-inquiries-contract.md).
 *
 * Gate: `requiresAuth` only — the API's read gate is any staff user, and it is
 * the real boundary. Release is gated again by the API's release policy.
 *
 * No realtime: the service publishes no events. Refresh re-runs onEnter.
 *
 * Registered BEFORE ClientDetail in clientsRoutesList: `/clients/:id/:tab?`
 * would otherwise swallow this path.
 */
const inquiryQueueRoute: RouteType[] = [
  {
    name: "InquiryQueue",
    path: "/clients/inquiry-queue",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Inquiry Queue",
        enableRefreshButton: true,
        component: () => import("./InquiryQueue.Header"),
      },
      body: {
        component: () => import("./InquiryQueue.Body"),
        grayBackground: true,
      },
    },
    group: "Clients",
    searchAliases: ["questions for clients", "client questions", "release inquiry", "open inquiries"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = storeOf(rootStore);
      if (!store) return;
      // `?open=<id>` (Meeting Detail → Client questions links here) opens that question once the list is in.
      const raw = (rootStore as { routerStore?: { queryParams?: Record<string, unknown> } }).routerStore?.queryParams?.open;
      const open = Number(Array.isArray(raw) ? raw[0] : raw);
      void store.initialize().then(() => store.openById(open));
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default inquiryQueueRoute;
